import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/sg_ready_icon.svg'

const SgReadyIcon: React.FC<SvgIconProps> = props => <SvgIcon viewBox="0 0 18 18" component={Icon} {...props} fill="currentColor" />
export default SgReadyIcon
